import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    "Faltan las variables de entorno de Supabase (VITE_PUBLIC_SUPABASE_URL y VITE_PUBLIC_SUPABASE_ANON_KEY).",
  );
}

// Bloqueo personalizado con tope de tiempo para evitar que la contención
// entre pestañas congele la página.
async function customLock(
  name: string,
  acquireTimeout: number,
  fn: () => Promise<unknown>,
): Promise<unknown> {
  if (navigator.locks?.request) {
    try {
      return await navigator.locks.request(name, { mode: "exclusive" }, async () => {
        let timer: ReturnType<typeof setTimeout> | undefined;
        const timeout = new Promise<never>((_, reject) => {
          timer = setTimeout(
            () => reject(new Error("Timeout adquiriendo lock de autenticación")),
            acquireTimeout,
          );
        });
        try {
          return await Promise.race([fn(), timeout]);
        } finally {
          if (timer) clearTimeout(timer);
        }
      });
    } catch {
      return await fn();
    }
  }
  return await fn();
}

export const supabase: SupabaseClient = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: "mark-direct-admin-auth",
    lock: customLock,
  },
});

export default supabase;